/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_In_ProgressInputs */



/**
* | output |
* | --- |
* | "Export in progress... please wait." |
*
* @param {Subtitle_Export_In_ProgressInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_in_progress = /** @type {((inputs?: Subtitle_Export_In_ProgressInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_In_ProgressInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exportation en cours... veuillez patienter.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Export läuft... bitte warten.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esportazione in corso... attendere prego.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выполняется экспорт... пожалуйста, подождите.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportación en progreso... por favor espere.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导出正在进行中……请稍候。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エクスポート中です...お待ちください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("निर्यात प्रक्रिया जारी है... कृपया प्रतीक्षा करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportação em andamento... aguarde.")
	return /** @type {LocalizedString} */ ("Export in progress... please wait.")
});